import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import TableHeader from '../../atoms/table/TableHeader';
import TableHeaderCell from '../../atoms/table/TableHeaderCell';
import styled from 'styled-components';
const Sticky = styled.div `
    position: sticky;
    position: -webkit-sticky;
    top: 78px;
    z-index: 1;
`;
const PaymentTableHeader = () => {
    return (_jsx(Sticky, { className: "sticky", children: _jsxs(TableHeader, { children: [_jsx(TableHeaderCell, { children: "Datum" }), _jsx(TableHeaderCell, { children: "Bedrag" }), _jsx(TableHeaderCell, { children: "Omschrijving" })] }) }));
};
export default PaymentTableHeader;
